import { CurrencyItem } from '@/models/dictionary/currency-list.model';
import { api } from '@/services/http.service';
import { defineStore } from 'pinia';
import { AvailableCurrencyListRequestModel } from '@/models/currency/currency.model';
import { showErrorNotification } from '@/utils/show-notification.util';

interface AvailableCurrencyListState {
  availableCurrencyList: CurrencyItem[];
  isAvailableCurrencyListLoading: boolean;
}

export const useAvailableCurrencyListStore = defineStore({
  id: 'AvailableCurrencyListStore',
  state: (): AvailableCurrencyListState => ({
    availableCurrencyList: [],
    isAvailableCurrencyListLoading: false,
  }),
  actions: {
    setAvailableCurrencyListLoading(isLoading: boolean): void {
      this.isAvailableCurrencyListLoading = isLoading;
    },
    getAvailableCurrencyList(whitelabelId: string): Promise<CurrencyItem[]> {
      this.setAvailableCurrencyListLoading(true);

      const payloadData: AvailableCurrencyListRequestModel = {
        filterList: {
          whitelabelId,
        },
      };

      return api.dictionary.getAvailableCurrencyListRequest.perform(payloadData)
        .then((currencyList: CurrencyItem[]) => {
          this.availableCurrencyList = currencyList;

          return currencyList;
        })
        .catch(error => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setAvailableCurrencyListLoading(false);
        });
    },
  },
});
